import { render, staticRenderFns } from "./sidepanel.vue?vue&type=template&id=88985b6a&scoped=true"
import script from "./sidepanel.vue?vue&type=script&lang=js"
export * from "./sidepanel.vue?vue&type=script&lang=js"
import style0 from "./sidepanel.vue?vue&type=style&index=0&id=88985b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88985b6a",
  null
  
)

export default component.exports